/**
* This component allows you to expand or contract long text when needed base on data attributes
* data-show-more for the see more button and data-long-text for the text and data-read-more-dots for the dots
*/
define(
  'frequentlyAskedQuestionsHandler',[],
  () => {
    'use strict';

    function toggleQuestionState(element, status) {
      element.setAttribute('data-ga-event-label', status);
    }

    const questions = document.querySelectorAll('[data-faq-question]');
    questions.forEach((question) => {
      question.addEventListener('click', (event) => {
        const target = event.target.closest('details');
        // check if the element is open, then change the analytics event if needed.
        const isOpen = target.open;
        const status = isOpen ? 'Close' : 'Open';
        toggleQuestionState(question, status);
      });
    });
  }

);

